module.exports = __webpack_public_path__ + "img/slide_digitro.a83fb4ec.png";